import Accordion from 'react-bootstrap/Accordion';
import { PageTitle } from "../../../../../_metronic/layout/core";
import PermissionsGate from "../../../../api/PermissionsGate";
import { SCOPES } from "../../../../config/permissions-map";
import { Unauthorized } from "../../../Global/unauthorized";
import ClienteConGarantia from './components/ClienteConGarantia';
import GarantiaPorVencimiento from "./components/GarantiaPorVencimiento";
import GradoDeAvance from './components/GradoDeAvance';

export default function DashboardGarantia({ title }) {
  const breadcrumbs = [
    {title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false},
    {title: "", path: "", isActive: false, isSeparator: true},
    {title: "Garantías", path: "", isActive: false, isSeparator: false},
  ];

  return (
    <>
      <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_DASHBOARD]} >
        <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>

        <Accordion defaultActiveKey={['0']} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Garantía Por Vencimiento</span></Accordion.Header>
            <Accordion.Body>
              <GarantiaPorVencimiento />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Grado De Avance</span></Accordion.Header>
            <Accordion.Body>
              <GradoDeAvance />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Cliente Con Garantía</span></Accordion.Header>
            <Accordion.Body>
              <ClienteConGarantia />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </PermissionsGate>
    </>
  )
}